import { createSlice } from "@reduxjs/toolkit";

export const organizationSlice = createSlice({
  name: "organization",
  initialState: {
    getOrganizationResult: false,
    getOrganizationLoading: false,
    getOrganizationError: false,
    addOrganizationResult: false,
    addOrganizationLoading: false,
    deleteOrganizationResult: false,
  },
  reducers: {
    organizationReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_ORGANIZATION":
          return {
            ...state,
            getOrganizationResult: payload.data,
            getOrganizationLoading: payload.loading,
            getOrganizationError: payload.error,
          };
        case "ADD_ORGANIZATION":
          return {
            ...state,
            addOrganizationResult: payload.data,
            addOrganizationLoading: payload.loading,
          };
        case "DELETE_ORGANIZATION":
          return {
            ...state,
            deleteOrganizationResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { organizationReducers } = organizationSlice.actions;

export default organizationSlice.reducer;
